import React, { useEffect } from "react";
import Router from "./routes/Router";
import { supabase } from "./config/supabaseClient";
import CLoader from "./components/CLoader";
import { Toast } from "./components/Toast";
import { roleType } from "./constant/constants";
import { useLocation } from "react-router-dom";
const checkAndCreateUser = async () => {
  const email = "ifundi123@mailinator.com";
  const password = "Ifundi!123";

  try {
    const { data: existingUser, error: userCheckError } = await supabase
      .from("company_user")
      .select("*")
      .eq("email", email)
      .single();

    if (userCheckError && userCheckError.code !== "PGRST116") {
      console.error("Error checking user:", userCheckError);
      return;
    }

    if (!existingUser) {
      const { data: authData, error: authError } =
        await supabase.auth.admin.createUser({
          email,
          password,
          user_metadata: { role: roleType.ADMIN },
          email_confirm: true,
        });

      const userId = authData?.user?.id; // Get the newly created user's ID
      if (!userId) throw new Error("User ID not found");

      const { data, error: insertError } = await supabase
        .from("company_user")
        .insert([
          {
            user_id: userId,
            // company_id: company_id, // Company selected
            first_name: "ifundi",
            last_name: "test",
            email: email,
            role: roleType.ADMIN,
            // contact_number: contact_number,
          },
        ])
        .select();

      // await supabase.from("company_user").insert([{ email, role: roleType.ADMIN }]);
    }
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};

function App() {
  useEffect(() => {
    checkAndCreateUser();
  }, []);

  const location = useLocation();
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: {
        url: location.pathname,
        title: document.title,
      },
    });
  }, [location]);

  return (
    <>
      <CLoader />
      <Toast />
      <Router />
    </>
  );
}

export default App;
